export const pronounList = ["She/her", "He/him", "They/them", "None of these"];

export default pronounList;
